import { useCallback } from 'react';
import { useRoutesContext } from '../index';

import { Station } from 'entities/stations';

export const useGetvisibleStationsByZoom = () => {
  const { visibleStationsByZoom } = useRoutesContext();

  const getVisibleStationsByZoom = useCallback((zoomLevel: number): (undefined | Station[]) => (
    (visibleStationsByZoom || {})[zoomLevel]
  ), [visibleStationsByZoom]);

  return getVisibleStationsByZoom;
};
